import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabNames: null,
    activeTab: { default: 0 }
  },
  emits: ["changeActiveTab"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeActiveTab', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tabNames: string[], activeTab: number };





watch(
  () => props.activeTab,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      selectedTab.value = newValue;
    }
  }
);

const selectedTab = computed({
  get: () => props.activeTab,
  set: (newValue) => {
    if (newValue !== props.activeTab) {
      emit('changeActiveTab', newValue);
    }
  },
});

return { __sfc: true,emit, props, selectedTab }
}

})